import { call, put, retry, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_PUBLICACAO,
  GET_PUBLICACOES_PENDENTES,
  UPDATE_PUBLICACAO,
} from "./actionTypes"
import {
  getPublicacoesSuccess,
  getPublicacoesFail,
  updatePublicacaoSuccess,
  updatePublicacaoFail,
  getPublicacaoSuccess,
  getPublicacaoFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getPublicacao,
  getPublicacaoPendentes,
  updatePublicacao,
} from "helpers/blopsleads_helper"

const RETRY_COUNT = 3
const RETRY_DELAY = 1000 // Milissegundos

function* fetchPublicacoesPendentes({ payload }) {
  try {
    const { filtros, page, pageSize } = payload
    const response = yield retry(
      RETRY_COUNT,
      RETRY_DELAY,
      getPublicacaoPendentes,
      filtros,
      page,
      pageSize
    )
    yield put(
      getPublicacoesSuccess({
        publicacoes: response.publicacoes,
        totalCount: response.totalCount,
        totalPages: response.totalPages,
        currentPageIndex: response.currentPageIndex,
      })
    )
  } catch (error) {
    yield put(getPublicacoesFail(error.message))
  }
}

function* fetchPublicacao({ payload: cnj }) {
  try {
    const response = yield call(getPublicacao, { cnj })

    const publicacoes = response.flatMap(processo => {
      const { Publicacoes } = processo
      if (Publicacoes && Publicacoes.length) {
        return Publicacoes.map(pub => ({ ...pub, Processo: processo }))
      }
      return [
        {
          Id: null,
          DataPublicacao: null,
          Prioridade: null,
          Status: null,
          Processo: processo,
        },
      ]
    })

    yield put(
      getPublicacoesSuccess({
        publicacoes,
        totalCount: 1,
        totalPages: 1,
        currentPageIndex: 1,
      })
    )
    yield put(getPublicacaoSuccess(publicacoes))
  } catch (error) {
    yield put(getPublicacaoFail(error))
  }
}

function* onUpdatePublicacao({ payload: data }) {
  try {
    const response = yield call(updatePublicacao, data)

    yield put(updatePublicacaoSuccess(response))
  } catch (error) {
    yield put(updatePublicacaoFail(error))
  }
}

function* PublicacaoSaga() {
  yield takeEvery(GET_PUBLICACOES_PENDENTES, fetchPublicacoesPendentes)
  yield takeEvery(GET_PUBLICACAO, fetchPublicacao)
  yield takeEvery(UPDATE_PUBLICACAO, onUpdatePublicacao)
}

export default PublicacaoSaga
